import { $convertToMarkdownString } from '@lexical/markdown';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { EditorState } from 'lexical';
import { useEffect, useMemo, useRef } from 'react';
import { MarkdownImage } from 'src/company/templates/hooks/useConvertToMarkdownMutation';
import { createTransformers } from '../config/transformers';
import { replaceImagesWithPlaceholders } from '../utils';

type OnChangePluginProps = {
  onChange?: (value: string) => void;
  placeholderImages: MarkdownImage[];
};

export function OnChangePlugin({ onChange, placeholderImages }: OnChangePluginProps) {
  const [editor] = useLexicalComposerContext();
  const onChangeRef = useRef(onChange);
  const placeholderImagesRef = useRef(placeholderImages);
  const transformers = useMemo(() => createTransformers(editor), [editor]);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    placeholderImagesRef.current = placeholderImages;
  }, [placeholderImages]);

  useEffect(() => {
    const removeListener = editor.registerUpdateListener(
      ({ editorState }: { editorState: EditorState }) => {
        editorState.read(() => {
          const markdown = $convertToMarkdownString(transformers);
          const withPlaceholders = replaceImagesWithPlaceholders(
            markdown,
            placeholderImagesRef.current,
          );
          onChangeRef.current?.(withPlaceholders);
        });
      },
    );

    return () => {
      removeListener();
    };
  }, [editor, transformers]);

  return null;
}
